import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-terms-policies',
  templateUrl: './terms-policies.component.html',
  styleUrls: ['./terms-policies.component.scss']
})
export class TermsPoliciesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
